"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTable = require("react-table");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bs = require("react-icons/bs");

var _reactBootstrap = require("react-bootstrap");

var _Pagination = _interopRequireDefault(require("../Pagination/Pagination"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Table = function Table(_ref) {
  var bordered = _ref.bordered,
      borderless = _ref.borderless,
      cantFiles = _ref.cantFiles,
      columns = _ref.columns,
      data = _ref.data,
      fetchData = _ref.fetchData,
      goForceReset = _ref.goForceReset,
      initialState = _ref.initialState,
      pageCount = _ref.pageCount,
      pagination = _ref.pagination,
      paintSection = _ref.paintSection,
      paintSectionColor = _ref.paintSectionColor,
      renderRowSubComponent = _ref.renderRowSubComponent,
      resetTableFlag = _ref.resetTableFlag,
      setInitialState = _ref.setInitialState,
      size = _ref.size,
      sortOrder = _ref.sortOrder,
      titleLeft = _ref.titleLeft,
      type = _ref.type,
      onRowClick = _ref.onRowClick;

  var _useTable = (0, _reactTable.useTable)({
    columns: columns,
    data: data,
    initialState: initialState,
    manualPagination: true,
    manualSortBy: true,
    pageCount: pageCount
  }, _reactTable.useSortBy, _reactTable.useExpanded, _reactTable.usePagination),
      headerGroups = _useTable.headerGroups,
      rows = _useTable.rows,
      page = _useTable.page,
      prepareRow = _useTable.prepareRow,
      nextPage = _useTable.nextPage,
      previousPage = _useTable.previousPage,
      pageOptions = _useTable.pageOptions,
      gotoPage = _useTable.gotoPage,
      setPageSize = _useTable.setPageSize,
      setSortBy = _useTable.setSortBy,
      _useTable$state = _useTable.state,
      pageIndex = _useTable$state.pageIndex,
      pageSize = _useTable$state.pageSize,
      sortBy = _useTable$state.sortBy;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      flagReset = _useState2[0],
      setFlagReset = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      flagSortBy = _useState4[0],
      setFlagSortBy = _useState4[1];

  var forceReset = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var resetPage, resetPageSize, resetSortBy;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              resetPage = _ref2.resetPage, resetPageSize = _ref2.resetPageSize, resetSortBy = _ref2.resetSortBy;
              setFlagReset(false);
              _context.next = 4;
              return setSortBy(resetSortBy || []);

            case 4:
              _context.next = 6;
              return setPageSize(resetPageSize || 10);

            case 6:
              setFlagReset(true);
              _context.next = 9;
              return gotoPage(resetPage || 0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function forceReset(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (goForceReset && goForceReset.current !== undefined) goForceReset.current = forceReset;
  }, []);
  (0, _react.useEffect)(function () {
    if (flagReset) {
      fetchData({
        pageIndex: pageIndex,
        pageSize: pageSize,
        sortBy: sortBy
      });
    }

    return function () {
      return null;
    };
  }, [pageIndex, pageSize, flagReset]);
  (0, _react.useEffect)(function () {
    if (flagSortBy) {
      // Si se cambia el método de ordenamiento se reinicia el paginado
      // Por transitividad luego de esto se ejecuta el Effect de abajo
      if (pageIndex) {
        gotoPage(0);
      } else {
        gotoPage(0);
        fetchData({
          pageIndex: pageIndex,
          pageSize: pageSize,
          sortBy: sortBy
        });
      }
    }
  }, [flagSortBy]);
  (0, _react.useEffect)(function () {
    if (resetTableFlag) {
      var _initialState$sortBy;

      if (initialState.pageIndex || initialState.pageSize !== 10 || (_initialState$sortBy = initialState.sortBy) !== null && _initialState$sortBy !== void 0 && _initialState$sortBy.length) {
        // Se tiene q reiniciar este valor
        // ya que genera un fetch con valores desactualizados
        setInitialState({
          pageIndex: 0,
          pageSize: 10,
          sortBy: []
        });
      }

      if (!pageIndex && pageSize === 10 && !sortBy.length) {
        // Si estoy en la primera página, sin filtros ni cambios en el pageSize
        fetchData({
          pageIndex: pageIndex,
          pageSize: pageSize,
          sortBy: sortBy
        });
      } else {
        // Si los params son distintos al initialState (0, 10, [])
        // Reiniciar valores de paginado
        forceReset({
          resetPage: 0,
          resetPageSize: pageSize,
          resetSortBy: []
        });
      }
    }
  }, [resetTableFlag]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "style-content-table ".concat(type)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
    responsive: size,
    hover: true,
    bordered: bordered,
    borderless: borderless,
    style: type === 'light' ? {
      backgroundColor: 'transparent'
    } : {}
  }, /*#__PURE__*/_react.default.createElement("thead", null, headerGroups.map(function (headerGroup, index) {
    return /*#__PURE__*/_react.default.createElement("tr", _extends({}, headerGroup.getHeaderGroupProps(), {
      key: index
    }), headerGroup.headers.map(function (column, index) {
      return /*#__PURE__*/_react.default.createElement("th", _extends({}, column.getHeaderProps(sortOrder && !column.hideSort && column.getSortByToggleProps()), {
        style: column.hideSort && !titleLeft ? {
          textAlign: 'center'
        } : {
          textAlign: 'left'
        },
        title: "",
        key: index,
        className: column.hideSort ? 'hide-sort' : '',
        onClick: function onClick() {
          if (sortOrder && !column.hideSort) {
            var sortColum = [];

            if (column.isSorted) {
              if (!column.isSortedDesc) {
                sortColum = {
                  id: column.id,
                  desc: !column.isSortedDesc
                };
                setSortBy([sortColum]);
                return setFlagSortBy(sortColum);
              }
            } else {
              sortColum = {
                id: column.id,
                desc: false
              };
              setSortBy([sortColum]);
              return setFlagSortBy(sortColum);
            }

            setSortBy([]);
            return setFlagSortBy([]);
          }
        }
      }), column.render('Header'), !column.hideSort && /*#__PURE__*/_react.default.createElement("span", {
        className: "reserved-space"
      }, column.isSorted ? column.isSortedDesc ? /*#__PURE__*/_react.default.createElement(_bs.BsChevronDown, null) : /*#__PURE__*/_react.default.createElement(_bs.BsChevronUp, null) : /*#__PURE__*/_react.default.createElement("span", {
        className: "unused-sort"
      }, /*#__PURE__*/_react.default.createElement(_bs.BsChevronExpand, null))));
    }));
  })), /*#__PURE__*/_react.default.createElement("tbody", null, !pagination ? rows.map(function (row, index) {
    prepareRow(row);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement("tr", _extends({}, row.getRowProps(), {
      onClick: function onClick() {
        return onRowClick({
          row: row
        });
      }
    }), row.cells.map(function (cell, index) {
      return /*#__PURE__*/_react.default.createElement("td", _extends({}, cell.getCellProps([{
        style: cell.column.style
      }]), {
        key: index
      }), cell.render('Cell'));
    })), row.isExpanded && renderRowSubComponent ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
      colSpan: 12
    }, renderRowSubComponent({
      row: row
    }))) : null);
  }) : page.map(function (row, index) {
    prepareRow(row);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement("tr", _extends({}, row.getRowProps(), {
      onClick: function onClick() {
        return onRowClick({
          row: row
        });
      }
    }), row.cells.map(function (cell, index) {
      var _cell$row;

      return paintSection && cell !== null && cell !== void 0 && (_cell$row = cell.row) !== null && _cell$row !== void 0 && _cell$row.original[paintSection] ? /*#__PURE__*/_react.default.createElement("td", _extends({}, cell.getCellProps([{
        style: cell.column.style
      }]), {
        style: {
          backgroundColor: paintSectionColor
        },
        key: index
      }), cell.render('Cell')) : /*#__PURE__*/_react.default.createElement("td", _extends({}, cell.getCellProps([{
        style: cell.column.style
      }]), {
        key: index
      }), cell.render('Cell'));
    })), row.isExpanded && renderRowSubComponent ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
      colSpan: 12
    }, renderRowSubComponent({
      row: row
    }))) : null);
  })))), pagination && /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    pageIndex: pageIndex,
    totalPages: pageOptions.length,
    gotoPage: gotoPage,
    nextPage: nextPage,
    setPageSize: setPageSize,
    previousPage: previousPage,
    size: pageSize,
    cantFiles: cantFiles
  }));
};

var _default = Table;
exports.default = _default;
Table.propTypes = {
  bordered: _propTypes.default.bool,
  borderless: _propTypes.default.bool,
  cantFiles: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.number), _propTypes.default.bool]),
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    Header: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element, _propTypes.default.func]),
    accessor: _propTypes.default.string,
    sortColumnName: _propTypes.default.string,
    Cell: _propTypes.default.func,
    id: _propTypes.default.string,
    style: _propTypes.default.object,
    hideSort: _propTypes.default.bool
  })).isRequired,
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  fetchData: _propTypes.default.func,
  goForceReset: _propTypes.default.object,
  initialState: _propTypes.default.object,
  pageCount: _propTypes.default.number,
  pagination: _propTypes.default.bool,
  paintSection: _propTypes.default.string,
  paintSectionColor: _propTypes.default.string,
  renderRowSubComponent: _propTypes.default.func,
  resetTableFlag: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  setInitialState: _propTypes.default.func,
  size: _propTypes.default.string,
  sortOrder: _propTypes.default.bool,
  titleLeft: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['light', '']),
  onRowClick: _propTypes.default.func
};
Table.defaultProps = {
  bordered: false,
  borderless: false,
  cantFiles: true,
  fetchData: function fetchData() {},
  goForceReset: null,
  initialState: {},
  pageCount: 0,
  pagination: false,
  paintSection: null,
  paintSectionColor: '',
  renderRowSubComponent: null,
  resetTableFlag: null,
  setInitialState: function setInitialState() {},
  size: 'sm',
  sortOrder: false,
  titleLeft: false,
  type: '',
  onRowClick: function onRowClick() {}
};